var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    transform: "translate(13 13)",
    d: "M14 1L2 1C0.89531231 1 0 1.8953123 0 3L0 13C0 14.104688 0.89531231 15 2 15L14 15C15.104688 15 16 14.104688 16 13L16 3C16 1.8953123 15.103125 1 14 1ZM3.5 13.5L2 13.5C1.7243123 13.5 1.4999995 13.275687 1.4999995 13L1.4999995 10.75L3.4999995 10.75L3.4999995 13.5L3.5 13.5ZM3.4999995 9.25L1.4999995 9.25L1.4999995 6.75L3.4999995 6.75L3.4999995 9.25ZM3.4999995 5.25L1.4999995 5.25L1.4999995 3C1.4999995 2.7243128 1.7243123 2.5 2 2.5L3.5 2.5L3.5 5.25L3.4999995 5.25ZM11 13.5L5 13.5L5 8.75L11 8.75L11 13.5ZM11 7.25L5 7.25L5 2.5L11 2.5L11 7.25ZM14.5 13C14.5 13.275687 14.275687 13.5 14 13.5L12.5 13.5L12.5 10.75L14.5 10.75L14.5 13ZM14.5 9.25L12.5 9.25L12.5 6.75L14.5 6.75L14.5 9.25ZM14.5 5.25L12.5 5.25L12.5 2.5L14 2.5C14.275687 2.5 14.5 2.7243128 14.5 3L14.5 5.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.66a62a5738756bf4925484d48e300cb8.svg";
export { ForwardRef as ReactComponent };